import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Tab } from '../../model/tab';
import { ProjectTabsService } from '../../services/project-tabs.service';
import { SubscriptionBasedComponent } from '../../subscription-helpers/subscription-based.component';
import { Project } from 'src/app/model/project/project';

@Component({
  selector: 'project-tabs-component',
  templateUrl: './project-tabs.component.html',
  styleUrls: ['./project-tabs.component.scss']
})
export class ProjectTabsComponent extends SubscriptionBasedComponent
  implements OnInit, OnDestroy {
  tabs: Tab[];

  init = false;

  @Input()
  inputProject: Project;

  @Output()
  addAdjustment = new EventEmitter();
  @Output()
  addSoldRented = new EventEmitter();
  @Output()
  addRepo = new EventEmitter();
  @Output()
  save = new EventEmitter();

  constructor(private projectTabsService: ProjectTabsService) {
    super();

    this.addSubscription(projectTabsService.tabClosed, event => {
      const activeTab = this.projectTabsService.getActiveTab();
      if (event.closedTab && event.closedTab === activeTab) {
        if (this.tabs.length > 0) {
          this.openTab(this.tabs[this.tabs.length - 1]);
        }
      }
    });
    this.addSubscription(projectTabsService.tabsChanged, event => {
      this.tabs = this.projectTabsService.getTabs();
    });
    this.tabs = [];
  }

  ngOnInit(): void {
    this.tabs = this.projectTabsService.getTabs();
    this.init = true;
  }

  ngOnDestroy() {
    this.tabs.forEach(tab => tab.component.destroy());
    //Obliterate what makes us weak!
  }

  openTab(tab: Tab) {
    this.projectTabsService.openTab(tab);
  }
}
